import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import EN from '../../assets/images/flags/en.webp';
import FI from '../../assets/images/flags/fi.webp';
import SW from '../../assets/images/flags/sw.webp';
import { useLanguage } from '../../services/LanguageContextProvider.js';
import { localizedPath } from '../../i18n/locales';


export const LanguageDropdown = () => {

    const { language } = useLanguage();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    // FI primary market first; FR dropped (no routable surface).
    const languages = {
        'FI': {
            flag: FI,
            languageName: 'Suomi'
        },
        'SW': {
            flag: SW,
            languageName: 'Svenska'
        },
        'EN': {
            flag: EN,
            languageName: 'English'
        }
    }

    // Changing language = navigating to the localized URL. LocaleSync (router)
    // then updates i18next + LanguageContext, so the URL stays the single truth.
    const handleOptionChange = (event) => {
        const nextLocale = event.target.value;
        const sub = pathname.endsWith('/horeca') ? 'horeca' : '';
        navigate(localizedPath(nextLocale, sub));
    };

    const current = languages[language] ?? languages.FI;

    return (
        <div className='dropdown-container'>
            <img src={current.flag} className='dropdown-flag navbar-buttons-section' alt={`${current.languageName} flag`} />
            <select className='dropdown-select' id="language" value={language} onChange={(event) => handleOptionChange(event)}>
                {Object.keys(languages).map((key) => (
                    <option className='dropdown-select-option' key={key} value={key}>{languages[key].languageName}</option>
                ))}
            </select>
        </div>
    )
}
